import { IsNorne } from "@portal/helpers/IsNorne";
import { IPortfolio } from "@portal/types/api/IPortfolio";

export const FilterPortfoliosByCenterId = (portfolios: IPortfolio[], centerId: string) => {
  if (IsNorne(centerId)) return portfolios;
  return portfolios.filter(p => p.centerId === centerId);
};
